import { render } from "./PantryUsedUpCheckView.vue?vue&type=template&id=2b6eb630&ts=true"
import script from "./PantryUsedUpCheckView.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpCheckView.vue?vue&type=script&lang=ts"

import "./PantryUsedUpCheckView.vue?vue&type=style&index=0&id=2b6eb630&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__